<template>
  <div>
    <DataLoader :is_on="loading" />
    <div class="case-spisi case-naplata">
      <div class="spisi-left">
        <div class="case-spisi-folders-line naplata-folders-line">
          <div :class="['troskovnici-button']" @click="switchTab('naplata')">
            <div>{{$t("billing_page.naplata_tabs.t1")}}</div>
            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="15" viewBox="0 0 13 15" fill="none">
              <path
                d="M3.54545 3.85135C3.54545 3.5155 3.81001 3.24324 4.13636 3.24324H9.65152C9.97787 3.24324 10.2424 3.5155 10.2424 3.85135C10.2424 4.1872 9.97787 4.45946 9.65152 4.45946H4.13636C3.81001 4.45946 3.54545 4.1872 3.54545 3.85135Z"
                fill="#2A306B" />
              <path
                d="M4.13636 5.67568C3.81001 5.67568 3.54545 5.94793 3.54545 6.28378C3.54545 6.61963 3.81001 6.89189 4.13636 6.89189H8.07576C8.40211 6.89189 8.66667 6.61963 8.66667 6.28378C8.66667 5.94793 8.40211 5.67568 8.07576 5.67568H4.13636Z"
                fill="#2A306B" />
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M3.74242 0C1.67554 0 0 1.72431 0 3.85135V11.9595C0 13.6387 1.32279 15 2.95455 15H11.6212C12.3827 15 13 14.3647 13 13.5811V1.41892C13 0.635272 12.3827 0 11.6212 0H3.74242ZM11.8182 8.91892V1.41892C11.8182 1.30697 11.73 1.21622 11.6212 1.21622H3.74242C2.32824 1.21622 1.18182 2.39601 1.18182 3.85135V9.5268C1.67562 9.1451 2.28941 8.91892 2.95455 8.91892H11.8182ZM11.8182 10.1351H2.95455C1.9755 10.1351 1.18182 10.9519 1.18182 11.9595C1.18182 12.967 1.9755 13.7838 2.95455 13.7838H11.6212C11.73 13.7838 11.8182 13.693 11.8182 13.5811V10.1351Z"
                fill="#2A306B" />
            </svg>
          </div>
          <div :class="['izdani-racuni-button', 'tab-middle']" @click="switchTab('izdane-fakture')">
            <div>{{$t("billing_page.naplata_tabs.t2")}}</div>
            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="15" viewBox="0 0 13 15" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M3.74242 0C1.67554 0 0 1.72431 0 3.85135V11.9595C0 13.6387 1.32279 15 2.95455 15H11.6212C12.3827 15 13 14.3647 13 13.5811V1.41892C13 0.635272 12.3827 0 11.6212 0H3.74242ZM11.8182 8.91892V1.41892C11.8182 1.30697 11.73 1.21622 11.6212 1.21622H3.74242C2.32824 1.21622 1.18182 2.39601 1.18182 3.85135V9.5268C1.67562 9.1451 2.28941 8.91892 2.95455 8.91892H11.8182ZM11.8182 10.1351H2.95455C1.9755 10.1351 1.18182 10.9519 1.18182 11.9595C1.18182 12.967 1.9755 13.7838 2.95455 13.7838H11.6212C11.73 13.7838 11.8182 13.693 11.8182 13.5811V10.1351Z"
                fill="#2A306B" />
              <g clip-path="url(#clip0_706_32)">
                <path
                  d="M7.54927 7.13067C6.92284 7.13067 6.37402 6.70904 6.07594 6.08176H8.04732V5.21245H5.84683C5.84135 5.14213 5.8384 5.07169 5.8384 4.99975C5.8384 4.92848 5.84133 4.85718 5.84683 4.7878H8.04736V3.91832H6.07596C6.37404 3.2911 6.92284 2.8696 7.54929 2.8696C8.14803 2.8696 8.71183 3.27042 9.02057 3.91517L9.80498 3.54025C9.35025 2.58994 8.48598 2 7.54927 2C6.8451 2 6.18785 2.32177 5.69857 2.90683C5.45248 3.20114 5.26446 3.54455 5.14085 3.91832H4.19531V4.78778H4.97517C4.97098 4.85762 4.96882 4.92895 4.96882 4.99973C4.96882 5.07125 4.97098 5.14166 4.97517 5.21243H4.19531V6.08174H5.14085C5.26446 6.45547 5.45248 6.79849 5.69859 7.09254C6.18787 7.67763 6.84512 8 7.54929 8C8.48602 8 9.35025 7.41014 9.80498 6.45985L9.02057 6.08423C8.71181 6.72982 8.14801 7.13067 7.54927 7.13067Z"
                  fill="#2A306B" />
              </g>
              <defs>
                <clipPath id="clip0_706_32">
                  <rect width="6" height="6" fill="white" transform="translate(4 2)" />
                </clipPath>
              </defs>
            </svg>
          </div>
          <div :class="['izdani-racuni-button', 'active']">
            <div>{{ $t("billing_page.naplata_tabs.t3") }}</div>
            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="15" viewBox="0 0 13 15" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M3.74242 0C1.67554 0 0 1.72431 0 3.85135V11.9595C0 13.6387 1.32279 15 2.95455 15H11.6212C12.3827 15 13 14.3647 13 13.5811V1.41892C13 0.635272 12.3827 0 11.6212 0H3.74242ZM11.8182 8.91892V1.41892C11.8182 1.30697 11.73 1.21622 11.6212 1.21622H3.74242C2.32824 1.21622 1.18182 2.39601 1.18182 3.85135V9.5268C1.67562 9.1451 2.28941 8.91892 2.95455 8.91892H11.8182ZM11.8182 10.1351H2.95455C1.9755 10.1351 1.18182 10.9519 1.18182 11.9595C1.18182 12.967 1.9755 13.7838 2.95455 13.7838H11.6212C11.73 13.7838 11.8182 13.693 11.8182 13.5811V10.1351Z"
                fill="#2A306B" />
              <path d="M4.2 7.6V5.4H5.4V7.6H4.2ZM6.3 7.6V3.6H7.5V7.6H6.3ZM8.4 7.6V2.2H9.6V7.6H8.4Z" fill="#2A306B" />
            </svg>
          </div>
        </div>

        <div v-if="forbidden" class="section hourly-message">{{ $t("analytics.hourly.forbidden") }}</div>
        <div v-else class="opening-folder">
          <div class="open-folder-line">
            <div class="open-folder-line-left">
              <div class="open-folder-icon-text-row">
                <div class="folder-tiny-icon">
                  <img src="@/assets/img/tiny-folder.png" />
                </div>
                <div class="folder-open-name">{{ $t("analytics.hourly.title") }}</div>
              </div>
            </div>
            <div v-if="can_print" class="generiraj-rocisnik-button" @click="print()">
              <template v-if="!printing">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 20 18">
                  <path fill="#2b2b41" d="M16.206 3.132H3.97a.387.387 0 0 1-.387-.387V1.738c0-.94.763-1.704 1.704-1.704h9.602c.941 0 1.704.763 1.704 1.704v1.007a.387.387 0 0 1-.387.387zM20 6.462v7.279c0 1.153-.938 2.09-2.09 2.09h-1.317v-3.097a2.79 2.79 0 0 0-2.788-2.788H6.371a2.79 2.79 0 0 0-2.788 2.788v3.098H2.267A2.093 2.093 0 0 1 .176 13.74v-7.28c0-1.152.938-2.09 2.09-2.09H17.91c1.153 0 2.091.938 2.091 2.09zM4.823 8.088a.93.93 0 1 0-1.86 0 .93.93 0 0 0 1.86 0zm9.911 4.646v4.337a.93.93 0 0 1-.929.929H6.371a.93.93 0 0 1-.93-.93v-4.336a.93.93 0 0 1 .93-.929h7.434a.93.93 0 0 1 .93.93z" />
                </svg>
                <span>{{ $t("analytics.hourly.print") }}</span>
              </template>
              <div v-else class="elastic-wrapp"><div class="dot-elastic"></div></div>
            </div>
          </div>

          <div class="naplata-filters hourly-filters">
            <CustomDropdown :id="'hourly_year'" class="wider" :additional_classes="'phase'" v-model="chosen_year" :drop_items="years" />
            <v-menu v-model="date_menu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="dateRangeText" readonly clearable :label="$t('analytics.hourly.period')"
                  append-icon="mdi-calendar" v-bind="attrs" @click:append="date_menu = !date_menu" v-on="on"
                  class="case-date-picker rocista-date-picker"></v-text-field>
              </template>
              <v-date-picker locale="hr" :first-day-of-week="1" v-model="date_range" range no-title></v-date-picker>
            </v-menu>
            <CustomDropdown :id="'hourly_invoiced'" class="wider" :additional_classes="'phase'" v-model="invoiced_id" :drop_items="invoiced_items" />
            <CustomDropdown :id="'hourly_service'" class="wider" :additional_classes="'phase'" v-model="service_type_id" :drop_items="service_items" />
            <v-text-field v-model="search" :label="$t('analytics.hourly.search')" clearable append-icon="mdi-magnify"
              class="case-date-picker rocista-date-picker"></v-text-field>
          </div>

          <div v-if="period_empty" class="section hourly-message">{{ $t("analytics.hourly.select_period") }}</div>
          <div v-else-if="load_error" class="section hourly-message">{{ $t("analytics.hourly.load_error") }}</div>

          <template v-else-if="stats">
            <div v-if="stats.warnings.possible_duplicate_entries > 0" class="hourly-warning">
              {{ $t("analytics.hourly.warn_duplicates", { n: stats.warnings.possible_duplicate_entries }) }}
            </div>
            <div v-if="stats.warnings.zero_rate_entries > 0" class="hourly-warning">
              {{ $t("analytics.hourly.warn_zero_rate", { n: stats.warnings.zero_rate_entries }) }}
            </div>
            <div v-if="stats.totals.entries === 0" class="section hourly-message">{{ $t("analytics.hourly.no_data") }}</div>

            <template v-else>
              <div class="hourly-kpis">
                <div class="section predmeti-zadaci-box">
                  <div class="predmeti-zadaci-title">{{ $t("analytics.hourly.col_hours") }}</div>
                  <div class="hourly-kpi-value">{{ formatMinutes(stats.totals.minutes) }}</div>
                </div>
                <div class="section predmeti-zadaci-box">
                  <div class="predmeti-zadaci-title">{{ $t("analytics.hourly.col_amount") }}</div>
                  <div class="hourly-kpi-value">{{ formatAmounts(stats.totals.amounts) }}</div>
                </div>
                <div class="section predmeti-zadaci-box">
                  <div class="predmeti-zadaci-title">{{ $t("analytics.hourly.col_bills") }}</div>
                  <div class="hourly-kpi-value">{{ stats.totals.bills }}</div>
                </div>
                <div class="section predmeti-zadaci-box">
                  <div class="predmeti-zadaci-title">{{ $t("analytics.hourly.col_cases") }}</div>
                  <div class="hourly-kpi-value">{{ stats.totals.cases }}</div>
                </div>
              </div>

              <div class="section hourly-card">
                <div class="hourly-note">
                  {{ $t("analytics.hourly.showing", { shown: filtered_lawyers.length, total: stats.lawyers.length }) }}
                  · {{ $t("analytics.hourly.participated_note") }}
                </div>
                <table class="hourly-table">
                  <thead>
                    <tr>
                      <th>{{ $t("analytics.hourly.col_lawyer") }}</th>
                      <th class="n">{{ $t("analytics.hourly.col_hours") }}</th>
                      <th class="n">{{ $t("analytics.hourly.col_amount") }}</th>
                      <th class="n">{{ $t("analytics.hourly.col_entries") }}</th>
                      <th class="n">{{ $t("analytics.hourly.col_bills") }}</th>
                      <th class="n">{{ $t("analytics.hourly.col_cases") }}</th>
                      <th class="n">{{ $t("analytics.hourly.col_participated") }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="l in filtered_lawyers"
                      :key="l.uid"
                      :class="['clickable', { selected: selected_uid === l.uid }]"
                      @click="selected_uid = selected_uid === l.uid ? null : l.uid"
                    >
                      <td>{{ l.name }}</td>
                      <td class="n">{{ formatMinutes(l.minutes) }}</td>
                      <td class="n">{{ formatAmounts(l.amounts) }}</td>
                      <td class="n">{{ l.entries }}</td>
                      <td class="n">{{ l.bills }}</td>
                      <td class="n">{{ l.cases }}</td>
                      <td class="n hourly-muted">{{ formatMinutes(l.participated_minutes) }}</td>
                    </tr>
                    <tr v-if="stats.unassigned.entries > 0">
                      <td class="hourly-muted"><i>{{ $t("analytics.hourly.unassigned") }}</i></td>
                      <td class="n">{{ formatMinutes(stats.unassigned.minutes) }}</td>
                      <td class="n">{{ formatAmounts(stats.unassigned.amounts) }}</td>
                      <td class="n">{{ stats.unassigned.entries }}</td>
                      <td></td><td></td><td></td>
                    </tr>
                    <tr class="total">
                      <td>{{ $t("analytics.hourly.total_all") }}</td>
                      <td class="n">{{ formatMinutes(stats.totals.minutes) }}</td>
                      <td class="n">{{ formatAmounts(stats.totals.amounts) }}</td>
                      <td class="n">{{ stats.totals.entries }}</td>
                      <td class="n">{{ stats.totals.bills }}</td>
                      <td class="n">{{ stats.totals.cases }}</td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div v-if="selected_lawyer" class="section hourly-card">
                <div class="hourly-card-title">{{ $t("analytics.hourly.detail_for", { name: selected_lawyer.name }) }}</div>
                <table class="hourly-table">
                  <thead>
                    <tr>
                      <th>{{ $t("analytics.hourly.col_date") }}</th>
                      <th>{{ $t("analytics.hourly.col_case") }}</th>
                      <th>{{ $t("analytics.hourly.col_bill") }}</th>
                      <th>{{ $t("analytics.hourly.col_service") }}</th>
                      <th>{{ $t("analytics.hourly.col_description") }}</th>
                      <th class="n">{{ $t("analytics.hourly.col_time") }}</th>
                      <th class="n">{{ $t("analytics.hourly.col_rate") }}</th>
                      <th class="n">{{ $t("analytics.hourly.col_amount") }}</th>
                      <th>{{ $t("analytics.hourly.col_role") }}</th>
                      <th>{{ $t("analytics.hourly.col_invoiced") }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="x in selected_entries" :key="x.uid" :class="{ dup: x.possible_duplicate }">
                      <td class="nowrap">{{ formatDate(x.date) }}</td>
                      <td>{{ x.broj_predmeta }}</td>
                      <td>{{ x.troskovnik_name }}</td>
                      <td>{{ x.service_type_name }}</td>
                      <td>{{ x.description }}</td>
                      <td class="n">{{ formatMinutes(x.minutes) }}</td>
                      <td class="n">{{ formatAmounts({ [x.currency]: Number(x.satnica) || 0 }) }}</td>
                      <td class="n">{{ x.role === "main" ? formatAmounts({ [x.currency]: x.amount }) : "—" }}</td>
                      <td :class="{ 'hourly-muted': x.role !== 'main' }">
                        {{ $t(x.role === "main" ? "analytics.hourly.role_main" : "analytics.hourly.role_participant") }}
                      </td>
                      <td>{{ $t(x.is_invoiced ? "analytics.hourly.yes" : "analytics.hourly.no") }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </template>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import CustomDropdown from "@/components/generalComponents/CustomDropdown.vue";
import DataLoader from "@/components/generalComponents/DataLoader";
import ms_calendar from "@/apiCallers/promise_handler_db/calendarSharepoint";
import { getHourlyBillingStats } from "@/apiCallers/promise_handler_db/analytics";
import { formatMinutes, formatAmounts, normalizeForSearch, describeFilters, buildHourlyPrintHtml } from "../hourlyFormat";

const INVOICED = { 0: "all", 1: "yes", 2: "no" };
const FIRST_YEAR = 2020;

function yearRange(year) {
  return [`${year}-01-01`, `${year}-12-31`];
}

export default {
  components: { CustomDropdown, DataLoader },
  data() {
    const year = new Date().getFullYear();
    return {
      chosen_year: year,
      date_range: yearRange(year),
      date_menu: false,
      invoiced_id: 0,
      service_type_id: 0,
      search: "",
      selected_uid: null,
      stats: null,
      loading: false,
      printing: false,
      forbidden: false,
      load_error: false,
      request_seq: 0,
    };
  },
  computed: {
    years() {
      const out = [{ id: 0, naziv: this.$t("analytics.hourly.custom_period") }];
      for (let y = new Date().getFullYear(); y >= FIRST_YEAR; y--) out.push({ id: y, naziv: y });
      return out;
    },
    invoiced_items() {
      return [
        { id: 0, naziv: this.$t("analytics.hourly.invoiced_all") },
        { id: 1, naziv: this.$t("analytics.hourly.invoiced_yes") },
        { id: 2, naziv: this.$t("analytics.hourly.invoiced_no") },
      ];
    },
    service_items() {
      const types = this.stats ? this.stats.service_types : [];
      return [{ id: 0, naziv: this.$t("analytics.hourly.service_all") }].concat(
        types.map((s) => ({ id: s.id, naziv: s.type_name }))
      );
    },
    // v-date-picker range keeps click order; the period is always earliest → latest.
    sorted_range() {
      return [...this.date_range].sort();
    },
    from() {
      return this.sorted_range[0];
    },
    to() {
      return this.sorted_range[1];
    },
    period_empty() {
      return this.date_range.length === 0;
    },
    // One date picked means the range is still being chosen: wait for the second click.
    period_incomplete() {
      return this.date_range.length < 2;
    },
    dateRangeText: {
      get() {
        return this.sorted_range.map((d) => moment(d).format("DD.MM.YYYY.")).join(" – ");
      },
      set(value) {
        if (value == null) this.date_range = [];
      },
    },
    // Only print what is on screen and settled: never stale numbers under changed filters.
    can_print() {
      return !!this.stats && !this.loading && !this.period_incomplete && !this.load_error;
    },
    query() {
      return {
        from: this.from,
        to: this.to,
        invoiced: INVOICED[this.invoiced_id],
        service_type: this.service_type_id || 0,
      };
    },
    filtered_lawyers() {
      if (!this.stats) return [];
      const q = normalizeForSearch(this.search);
      return q ? this.stats.lawyers.filter((l) => normalizeForSearch(l.name).includes(q)) : this.stats.lawyers;
    },
    selected_lawyer() {
      return this.stats ? this.stats.lawyers.find((l) => l.uid === this.selected_uid) || null : null;
    },
    selected_entries() {
      if (!this.selected_lawyer) return [];
      const uid = this.selected_uid;
      return this.stats.entries
        .filter((x) => x.person_uid === uid || x.multi_person_uid.includes(uid))
        .map((x) => Object.assign({}, x, { role: x.person_uid === uid ? "main" : "participant" }));
    },
  },
  watch: {
    chosen_year(year) {
      if (year) this.date_range = yearRange(year);
    },
    // A hand-picked range that isn't a whole year switches the dropdown to "custom".
    date_range(range) {
      const [from, to] = [...range].sort();
      const whole = yearRange(this.chosen_year);
      if (this.chosen_year && (from !== whole[0] || to !== whole[1])) this.chosen_year = 0;
    },
    query: {
      handler() {
        this.refresh();
      },
      deep: true,
    },
    // Searching for exactly one lawyer opens their entries straight away.
    filtered_lawyers(list) {
      if (this.search && list.length === 1) this.selected_uid = list[0].uid;
    },
  },
  mounted() {
    this.$store.state.paginacija.title = this.$t("breadcrumbs.general_naplata");
    this.refresh();
  },
  methods: {
    formatMinutes,
    formatAmounts,
    formatDate(iso) {
      return moment(iso).format("DD.MM.YYYY.");
    },
    switchTab(nastavak) {
      this.$router.push("/" + nastavak);
    },
    async refresh() {
      if (this.period_incomplete) return;
      // Ignore responses that arrive after a newer request was sent.
      const seq = ++this.request_seq;
      this.loading = true;
      this.load_error = false;
      try {
        const resp = await getHourlyBillingStats(this.query);
        if (seq !== this.request_seq) return;
        this.stats = resp.data;
        if (this.selected_uid && !this.stats.lawyers.some((l) => l.uid === this.selected_uid)) this.selected_uid = null;
      } catch (err) {
        if (seq !== this.request_seq) return;
        if (err.response && err.response.status === 403) this.forbidden = true;
        else this.load_error = true;
        this.stats = null;
      } finally {
        if (seq === this.request_seq) this.loading = false;
      }
    },
    async print() {
      if (this.printing || !this.can_print) return;
      this.printing = true;
      const user = this.$store.state.logged_in_user;
      const t = (key, values) => this.$t(key, values);
      const html = buildHourlyPrintHtml({
        t,
        stats: this.stats,
        lawyers: this.filtered_lawyers,
        selected: this.selected_lawyer,
        entries: this.selected_entries,
        filterText: describeFilters({ t, filters: this.stats.filters, serviceTypes: this.stats.service_types }),
        searchText: this.search,
        generatedBy: user ? `${user.ime || ""} ${user.prezime || ""}`.trim() : "",
        generatedAt: moment().format("DD.MM.YYYY. HH:mm"),
      });
      try {
        const resp = await ms_calendar.printCalendar(html);
        const url = window.URL.createObjectURL(new Blob([resp.data], { type: "application/pdf" }));
        const link = document.createElement("a");
        link.href = url;
        link.download = `${this.$t("analytics.hourly.title")} ${this.stats.filters.from} - ${this.stats.filters.to}.pdf`;
        link.click();
        setTimeout(() => window.URL.revokeObjectURL(url), 100);
      } finally {
        this.printing = false;
      }
    },
  },
};
</script>

<style scoped>
/* The root stays an unstyled <div>: router-view puts .router-wrapper on it, and that class
   carries the padding that keeps the page clear of the side nav. */
.hourly-filters {
  margin-left: 0;
  margin-bottom: 2.5rem;
  flex-wrap: wrap;
  align-items: center;
}
.hourly-message {
  color: #606076;
}
.hourly-warning {
  background: #fff4e0;
  color: #8a5300;
  border-radius: 0.6rem;
  padding: 1rem 1.6rem;
  margin-bottom: 1rem;
  font-weight: 500;
}
.hourly-kpis {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 1.5rem;
  margin-bottom: 1.5rem;
}
@media (max-width: 990px) {
  .hourly-kpis {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
.hourly-kpis .section {
  flex-direction: column;
  flex-wrap: nowrap;
  gap: 0.8rem;
  margin-bottom: 0;
  border-radius: 0.4rem;
  box-shadow: 7px 12px 35px rgba(76, 76, 95, 0.1);
}
.hourly-kpi-value {
  font-size: 2rem;
  font-weight: 700;
  color: #2b2b41;
  font-variant-numeric: tabular-nums;
}
.hourly-card {
  flex-direction: column;
  flex-wrap: nowrap;
  overflow-x: auto;
}
.hourly-card-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #2a306b;
  margin-bottom: 1rem;
}
.hourly-note {
  color: #7b7b8a;
  font-size: 1.2rem;
  margin-bottom: 1rem;
}
.hourly-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 1.3rem;
}
.hourly-table th {
  text-align: left;
  color: #2a306b;
  font-weight: 600;
  padding: 1rem;
  border-bottom: 1px solid #d3dce8;
  white-space: nowrap;
}
.hourly-table td {
  padding: 1rem;
  border-bottom: 1px solid #edeef2;
  color: #2b2b41;
  vertical-align: top;
}
.hourly-table .n {
  text-align: right;
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}
.hourly-table .nowrap {
  white-space: nowrap;
}
.hourly-table tr.clickable {
  cursor: pointer;
}
.hourly-table tr.clickable td {
  transition: background 0.2s ease;
}
.hourly-table tr.clickable:hover td {
  background: #f9f9fb;
}
.hourly-table tr.selected td {
  background: #f0efff;
}
.hourly-table tr.selected td:first-child {
  box-shadow: inset 3px 0 0 #3326ae;
  color: #3326ae;
  font-weight: 600;
}
.hourly-table tr.total td {
  font-weight: 700;
  border-top: 1px solid #d3dce8;
  border-bottom: none;
}
.hourly-table tr.dup td {
  background: #fff4e0;
}
.hourly-table .hourly-muted,
.hourly-muted {
  color: #7b7b8a;
}
</style>
